import React from 'react';
import { useSelector } from 'react-redux';
import { PriceBlock, PunchOut } from '@hpi-sox/hpstellar-core';
import { RewardBadge } from '@hpi-sox/hpstellar-core/visId';

import { withError } from '../../../../../shared/components/error-boundary';
import useUserData, { getPStoreID } from '../../../../../hooks/useUserData';
import { useGetProductPrice } from '../../../../../hooks/useProductPrice';
import { getPriceProps, getPunchOutProps } from '../../../../get-product-props/cart';
import { getRewardsBadge } from '../../../../get-product-props/util';

import Compare from './compare';
import CTARow from './cta-row';

import './product-footer.less';

export const PriceContainer = ({ product, isMobile }) => {
    const price = useGetProductPrice(product);
    const priceProps = getPriceProps(product, price, { hasPriceSeoText: true });
    const { punchOutProps } = getPunchOutProps(price) || {};
    // TODO: These are extra props generated by getPriceProps. Review if still needed.
    const { translations, customSaleText, customPrefix, productType, showInCartText, msrp } = priceProps || {};
    const extraProps = { translations, customSaleText, customPrefix, productType, showInCartText, msrp };
    const mobileProps = isMobile ? { wrapStrikePrice: true, wrapPriceDiff: true } : {};
    return (
        <div className="visid-price-container">
            <PriceBlock {...price} {...extraProps} style="left" {...mobileProps} className="price-block" />
            {punchOutProps && <PunchOut {...punchOutProps} />}
        </div>
    );
};

export const RewardBadgeContainer = ({ product }) => {
    const { userData } = useUserData();
    const rewardBadge = getRewardsBadge(product, getPStoreID(userData));
    const { message: label, tooltipContent } = rewardBadge || {};
    const { title, description: content } = tooltipContent || {};
    const TooltipProps = { title, content, triggerButtonProps: { 'aria-label': `Tooltip for ${label}` } };
    if (!rewardBadge) return null;

    return <RewardBadge label={label} TooltipProps={TooltipProps} color="purple" className="rewards-badge" />;
};

export default withError(({ product, productLinkProps, analyticsData, options }) => {
    const isMobile = useSelector(
        state => state && state.ui && state.ui.customBreakpoints && state.ui.customBreakpoints.visId === 'xsmall',
    );

    const priceAndCta = (
        <>
            <PriceContainer product={product} isMobile={isMobile} />
            <CTARow
                product={product}
                productLinkProps={productLinkProps}
                analyticsData={analyticsData}
                options={options}
                isMobile={isMobile}
            />
        </>
    );

    return (
        <div className="visid-product-tile-footer">
            <Compare product={product} />
            <RewardBadgeContainer product={product} />
            {isMobile ? <div className="visid-product-tile-cta-and-price-mobile">{priceAndCta}</div> : priceAndCta}
        </div>
    );
});
